import { Card, CardContent } from '@mui/material';
import { useTheme, useTranslate } from 'react-admin';
import { MapContainer, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'
import L, { LatLngExpression, Map as LeafletMap } from 'leaflet';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { LegendPanel } from '../../../components/map-legend-panel/map-legend-panel';
import { TransactionDataDto, TransactionsDataDistribution } from '@models/transactions-data';

import './HeatLayer.js';
import { useValueRange } from '../../../hooks/use-value-range';
import { useColor } from '../../../hooks/use-color';

export const TransactionsDataMap = ({ dataDistribution }: { dataDistribution: TransactionsDataDistribution }) => {
  const translate = useTranslate();
  const [map, setMap] = useState<LeafletMap | null>(null);
  const [initialCenter] = useState<LatLngExpression>([29.6827427, -95.4643671]);
  const [dataMin, dataMax] = useValueRange();
  const [getColorByValue] = useColor();

  
  const [theme] = useTheme();
  
  const gradient = useMemo(() => {
    const steps = 9;
    const min = 0;
    const max = 1.0;
    const stepGradient = (max - min) / (steps - 1);
    const stepValue = (dataMax - dataMin) / (steps - 1);
    const res: { [key: number]: string } = {}
    for (let currValue = dataMin, currGradient = min, step = 0; step < steps; step++, currValue += stepValue, currGradient += stepGradient) {
      res[currGradient] = getColorByValue(currValue);
    }
    return res;
  }, [getColorByValue, dataMin, dataMax]);

  const getValue = useCallback((d: TransactionDataDto) => {
    const value = d.dataMean;
    let offset = (value - dataMin) / (dataMax - dataMin);
    if (offset >= 1.0) offset = 1.0;
    if (offset < 0) offset = 0;
    return offset;
  }, [dataMin, dataMax])

  useEffect(() => {
    if (!map) return;
    if (!dataDistribution.data) return;

    var heat = L.heatLayer(
      dataDistribution.data.map((d) => [d.latLon[0], d.latLon[1], getValue(d)]),
      {
        radius: 25,
        blur: 15,
        minOpacity: 0.25,
        gradient
      }
    ).addTo(map);

    return () => {
      map.removeLayer(heat);
    }
  }, [map, dataDistribution, gradient]);

  const defaultFeatureStyle = {
    color: 'red',
    weight: 3,
    opacity: 0.5,
    fillOpacity: 0.5
  };

  return (
    <Card>
      <CardContent>
        <MapContainer
          center={initialCenter}
          zoom={9}
          style={{ width: '100%', height: '75vh' }}
          ref={setMap}
          preferCanvas={true}
          key={theme} // use key to force re-render on theme change
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            className={ theme === 'dark' ? 'map-tiles' : ''}
          />

          <LegendPanel />
          {/* <MapInfoPanelControl zipDataMap={zipDataMap} dataType={dataType} /> */}
        </MapContainer>
      </CardContent>
    </Card>
  );
};
